import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../api";

function ReconciliationReFinalizePage() {
  const { accountId } = useParams();
  const navigate = useNavigate();

  const [date, setDate] = useState("");
  const [systemBalance, setSystemBalance] = useState(0);
  const [actualCash, setActualCash] = useState(0);
  const [note, setNote] = useState("");
  const [variance, setVariance] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // If you want to load the account or confirm it's in reOpenMode, you could do that here
  useEffect(() => {
    // Example: fetch the account or ensure it's in reOpenMode
  }, []);

  useEffect(() => {
    setVariance(actualCash - systemBalance);
  }, [systemBalance, actualCash]);

  async function handleRefinalize() {
    if (!date) {
      alert("Please select a date");
      return;
    }
    setLoading(true);
    setError("");
    const payload = {
      accountId,
      date,
      systemBalance,
      actualCash,
      note,
    };
    try {
      const res = await API.post("/reconciliations/refinalize", payload);
      alert(res.data.message);
      navigate("/reconciliations");
    } catch (err) {
      console.error("Refinalize error:", err);
      setError("Failed to re-finalize.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="container">
      <h2>Re-Finalize Account</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}

      <p>Account ID: {accountId}</p>

      <div className="mb-3">
        <label>Date</label>
        <input
          type="date"
          className="form-control"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label>System Balance</label>
        <input
          type="number"
          className="form-control"
          value={systemBalance}
          onChange={(e) => setSystemBalance(Number(e.target.value))}
        />
      </div>

      <div className="mb-3">
        <label>Actual Cash</label>
        <input
          type="number"
          className="form-control"
          value={actualCash}
          onChange={(e) => setActualCash(Number(e.target.value))}
        />
      </div>

      <div className="mb-3">
        <label>Variance</label>
        <input
          type="number"
          className="form-control"
          disabled
          value={variance}
        />
      </div>

      <div className="mb-3">
        <label>Note</label>
        <textarea
          className="form-control"
          rows={3}
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </div>

      <button
        className="btn btn-primary"
        disabled={loading}
        onClick={handleRefinalize}
      >
        {loading ? "Re-Finalizing..." : "Re-Finalize"}
      </button>
    </div>
  );
}

export default ReconciliationReFinalizePage;
